import type { SelectOption, SelectOptionStatus } from '@/components/SearchableSelect'
import type { MonthSummaryItem } from '@/services/bankRecon'
import { incomeAllocationMonthsRange } from '@/utils/allocationFormat'
import { reportMonthLabel } from '../distribution-waterfall/waterfallJeStatus'
import { parseAccountStatus } from './bankReconRows'

function deriveMonthSelectStatus(
  accounts: MonthSummaryItem['accounts'],
  bankReconciledChecked = false,
): SelectOptionStatus {
  if (bankReconciledChecked) return 'complete'
  if (accounts.length === 0) return 'incomplete'
  const reconciledCount = accounts.filter(
    (entry) => parseAccountStatus(entry.status).kind === 'reconciled',
  ).length
  if (reconciledCount === accounts.length) return 'complete'
  if (reconciledCount >= 1) return 'partial'
  return 'incomplete'
}

export function mergeBankReconMonthSelectOptions(
  apiMonths: MonthSummaryItem[],
  asOf?: Date,
): SelectOption[] {
  const byMonth = new Map(apiMonths.map((entry) => [entry.report_month, entry]))

  return incomeAllocationMonthsRange(asOf).map((reportMonth) => {
    const entry = byMonth.get(reportMonth)
    const accounts = entry?.accounts ?? []
    return {
      id: reportMonth,
      label: reportMonthLabel(reportMonth),
      status: deriveMonthSelectStatus(accounts, entry?.bank_reconciled_checked),
    }
  })
}
